// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"TabBar_tabBar__2S_Z4","selected":"TabBar_selected__1PpD0"};